import React, { useEffect } from "react"
import validator from "validator"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import PPPictureBoxLoad from "../pricetable/PPPictureBoxLoad"
import { PPCompetitors } from "./PPCompetitor"
import useRequireAuth from "../../hooks/use-require-auth"
import PPUtils from "../../utils/PPUtils"
import { PPRightTabComment } from "./PPRightTabComment"
import "../../styles/righttab.css"

export default function PPrightTabMatching(props) {
    const [t] = useTranslation()
    let matchingURL = ""

    function validateURL(url) {
        const errors = {}
        let shopUrlInfo = new URL(props.selectedProductRow?.shopDomain)

        if (url.startsWith("appcrawl://")) {
            return errors
        }

        if (!validator.isURL(url, { validate_length: false })) {
            errors.url = t("pricetable.righttab.url.error.urlformat")
        }

        if (!url?.toLowerCase().includes(shopUrlInfo.hostname.toLowerCase())) {
            errors.url = t("pricetable.righttab.url.error.shopname")
        }

        // Google Shopping URL Validierung
        let googleHash = ""
        try {
            googleHash = new URL(url).hash.toLowerCase()
        } catch (error) {
            googleHash = ""
        }

        if (
            url.includes("google.com") &&
            !url.includes("shopping/product") &&
            !url.includes("oshopproduct") &&
            !url.includes("#sv") &&
            !googleHash.includes("sv=")
        ) {
            errors.url = t("pricetable.righttab.url.error.googleshopping")
        }

        return errors
    }

    function getTarifIdFromTariffuxx(url) {
        const regex = /[?&]product_config=([^&]+)/

        const match = url.match(regex)

        if (match?.[1]) {
            return match[1]
        } else {
            return null
        }
    }

    function startMatchingAfterValidation() {
        if (matchingURL.includes("google")) {
            let google_domains = ["google.de", "google.at", "google.ch"]
            google_domains.forEach(function (el_domain) {
                if (matchingURL.includes(el_domain)) {
                    matchingURL = matchingURL.replace(el_domain, "google.com")
                }
            })
            matchingURL = transformGoogleShoppingURL(matchingURL)
        }
        if (props.selectedProductRow?.shopDomain.includes("picnic.de") && !matchingURL.startsWith("appcrawl://")) {
            matchingURL = "appcrawl://picnic.de/" + matchingURL
        }
        if (
            props.selectedProductRow?.shopDomain.includes("preisvergleich.de") &&
            matchingURL.includes("tariffuxx.de/handytarife/angebot")
        ) {
            const tarifId = getTarifIdFromTariffuxx(matchingURL)
            if (tarifId === null) {
                toast.error(t("pricetable.righttab.url.error.urlformat"))
                return
            }
            matchingURL = "https://handy.preisvergleich.de/rechner/handytarife/#" + tarifId
        }
        const errors = validateURL(matchingURL)
        if (Object.keys(errors)?.length === 0) {
            props.onIcButtonClick(matchingURL, 1)
        } else {
            toast.error(errors.url)
        }
        document.getElementById("inputURL").value = ""
    }

    function transformGoogleShoppingURL(vMatchingURL) {
        // Entferne unerwünschte Google-Parameter nur bei URLs mit #oshopproduct
        // Diese Parameter sind für das Matching nicht relevant und können zu Problemen führen
        let cleanedURL = vMatchingURL
        
        if (cleanedURL.includes("#oshopproduct")) {
            let urlParts = cleanedURL.split('#')
            let beforeHash = urlParts[0]
            let afterHash = urlParts.slice(1).join('#')
            
            // Entferne Parameter nur aus dem Teil vor dem #
            // WICHTIG: Das erste ? darf nicht entfernt werden!
            
            // Entferne Parameter, aber schütze das erste ?
            beforeHash = beforeHash.replace(/&ei=[^&]*/g, '')           // "ei" Parameter (nur &, nicht ?)
            beforeHash = beforeHash.replace(/&oq=[^&]*/g, '')           // "oq" Parameter (nur &, nicht ?)
            beforeHash = beforeHash.replace(/&gs_lp=[^&]*/g, '')        // "gs_lp" Parameter (nur &, nicht ?)
            beforeHash = beforeHash.replace(/&sca_esv=[^&]*/g, '')      // "sca_esv" Parameter (nur &, nicht ?)
            beforeHash = beforeHash.replace(/&ved=[^&]*/g, '')          // "ved" Parameter (nur &, nicht ?)
            beforeHash = beforeHash.replace(/&sei=[^&]*/g, '')          // "sei" Parameter (nur &, nicht ?)
            
            // Bereinige doppelte & Zeichen (aber behalte das erste ?)
            beforeHash = beforeHash.replace(/&&/g, '&')
            
            // Falls nach der Bereinigung ?& am Anfang steht, entferne das &
            if (beforeHash.startsWith('?&')) {
                beforeHash = beforeHash.replace(/^\?&/, '?')
            }
            
            // Falls nach der Bereinigung & am Ende steht, entferne es
            if (beforeHash.endsWith('&')) {
                beforeHash = beforeHash.slice(0, -1)
            }
            
            // Falls nur noch ? übrig bleibt, entferne es
            if (beforeHash.endsWith('?')) {
                beforeHash = beforeHash.slice(0, -1)
            }
            
            // Setze die URL wieder zusammen
            cleanedURL = afterHash ? beforeHash + '#' + afterHash : beforeHash
        }
        
        // Ursprüngliche Logik für hl Parameter beibehalten (nur wenn keine #oshopproduct vorhanden)
        if (!cleanedURL.includes("#oshopproduct") && !cleanedURL.includes("?hl") && cleanedURL.includes("&hl=") && !cleanedURL.includes("search?q=")) {
            let newGSURL = cleanedURL.substring(0, cleanedURL.indexOf("?") + 1)
            newGSURL += cleanedURL.substring(cleanedURL.indexOf("hl="), cleanedURL.indexOf("hl=") + 5)
            return newGSURL
        }
        
        return cleanedURL
    }

    useEffect(() => {
        if (!document.body.classList.contains("control-sidebar-slide-open")) {
            const inputEl = document.getElementById("inputURL")
            if (inputEl) inputEl.value = ""
        }
    })

    //extra wegen Flaschenpost
    const auth = useRequireAuth()
    const currentAuth = PPUtils.getCurrentAuthFromAuth(auth)
    const producer = props.selectedProductRow?.producer?.trim() || '';
    const productName = props.selectedProductRow?.productName?.trim() || '';

    const searchTerm = (producer && 
    !productName.toLowerCase().includes(producer.toLowerCase()))
    ? `${producer} ${productName}`
    : productName;

    return (
        <>
            <div className="pp-righttab-close">
                <button id="sidebarclose" type="button" className="btn-close" aria-label="Close" />
            </div>
            <div className="d-flex align-items-center bg-white me-0 my-3 m-3">
                <div className="productimgbox">
                    <PPPictureBoxLoad image={props.selectedProductRow?.imageUrl} className={"img-fluid"} />
                </div>
                <div>
                    <h5 className="col px-3 p-2 align-self-start">{props.selectedProductRow?.productName}</h5>
                    <p className="col px-3">Shop: <a href={props.selectedProductRow?.shopDomain} target='_blank' rel="noopener noreferrer">{props.selectedProductRow?.shopName}
                    <i className={"fas fa-external-link-alt righttab-icon"} />
                    </a></p>
                    <p className="col px-3">
                        {t("single.category")}: {props.selectedProductRow?.department}
                    </p>
                    <p className="col px-3">
                        {PPUtils.isTariffComparisonMode(props?.selectedProductRow?.tariffComparisonMode)
                            ? PPUtils.getTariffComparisonModeProducerString(t)
                            : t("single.manufacturer")}
                        : {props.selectedProductRow?.producer}
                    </p>
                </div>
            </div>
            <div className="card card-primary card-outline card-outline-tabs m-3">
                <div className="card-header p-0 border-bottom-0">
                    <ul className="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                        <li className="nav-item active">
                            <a
                                className="nav-link active"
                                id="custom-tabs-four-matching-tab"
                                data-bs-toggle="pill"
                                href="#custom-tabs-four-matching"
                                role="tab"
                                onClick={() => window.dispatchEvent(new Event("resize"))}
                                aria-controls="custom-tabs-four-matching"
                                aria-selected="true">
                                {t("pricetable.righttab.url.label_matching")}
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="custom-tabs-four-suggestions-tab"
                                data-bs-toggle="pill"
                                href="#custom-tabs-four-suggestions"
                                role="tab"
                                aria-controls="custom-tabs-four-suggestions"
                                aria-selected="false">
                                {t("pricetable.righttab.suggestions")}
                            </a>
                        </li>
                        {currentAuth.customer.name !== "Flaschenpost" && (
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    id="custom-tabs-four-comment-tab"
                                    data-bs-toggle="pill"
                                    href="#custom-tabs-four-comment"
                                    role="tab"
                                    aria-controls="custom-tabs-four-comment"
                                    aria-selected="false">
                                    {t("pricetable.righttab.comment")}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>

                <div className="card-body">
                    <div className="tab-content" id="custom-tabs-four-tabContent">
                        <div
                            className="tab-pane fade active show"
                            id="custom-tabs-four-matching"
                            role="tabpanel"
                            aria-labelledby="custom-tabs-four-matching-tab">
                            <p>
                                {t("pricetable.righttab.url.infotext1")}
                                <br />
                                {t("pricetable.righttab.url.infotext2")}
                            </p>
                            <div>
                                <label>{t("pricetable.righttab.url.label_to_link")}</label>
                                <div className="input-group">
                                    <input
                                        onChange={(e) => (matchingURL = e.target.value)}
                                        type="input"
                                        className="form-control"
                                        id="inputURL"
                                        placeholder="https://example.url/product/12"
                                    />
                                    {props.selectedProductRow?.shopDomain.includes("https://www.google.com") && (
                                        <button
                                        type="button"
                                        onClick={() => window.open(`https://www.google.com/search?tbm=shop&source=hp&hl=de&q=${encodeURIComponent(searchTerm)}`, '_blank')}
                                        className="btn btn-primary">
                                            <i className="fab fa-google"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                            <br />
                            <button
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#urlMatchingModal"
                                className="btn w-100 btn-primary">
                                {t("pricetable.righttab.url.label_start_matching")}
                            </button>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="custom-tabs-four-suggestions"
                            role="tabpanel"
                            aria-labelledby="custom-tabs-four-suggestions-tab">
                            <PPCompetitors
                                productId={props.selectedProductRow?.id}
                                shopId={props.selectedProductRow.shopId}
                                productNr={props.selectedProductRow?.productNr}
                                refetchPricetable={props.refetchPricetable}
                                onIcButtonClick={props.onIcButtonClick}
                            />
                        </div>
                        {currentAuth.customer.name !== "Flaschenpost" && (
                            <div
                                className="tab-pane fade"
                                id="custom-tabs-four-comment"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-comment-tab">
                                <PPRightTabComment
                                    comment={props.selectedProductRow.comment}
                                    saveCommentMappingEditinfo={props.saveCommentMappingEditinfo}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                data-bs-backdrop="false"
                id="urlMatchingModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="urlMatchingModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="urlMatchingModalLabel">
                                {t("pricetable.righttab.url.label_matching")}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            {t("pricetable.righttab.url.modal_text")}{" "}
                            <ul>
                                <li>{t("pricetable.righttab.url.modal_text_info_1")}</li>
                                <li>{t("pricetable.righttab.url.modal_text_info_2")}</li>
                            </ul>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                {t("single.cancel")}
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary"
                                ref={props.icBtnRef}
                                data-bs-dismiss="modal"
                                onClick={startMatchingAfterValidation}>
                                {t("pricetable.righttab.url.label_start_matching")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
